export default "/_next/static/images/ba82c720d96684d1364d0fd245f623d4.jpg";